export default __webpack_public_path__ + "static/media/anna.309bca3e.bin";